var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "jade-dropdown",
        {
          attrs: { open: _vm.dropdownOpen },
          on: {
            closePopover: function ($event) {
              _vm.dropdownOpen = false
            },
            toggleOpen: function ($event) {
              _vm.dropdownOpen = !_vm.dropdownOpen
            },
          },
          scopedSlots: _vm._u([
            {
              key: "trigger",
              fn: function () {
                return [
                  _c(
                    "jade-action-button",
                    {
                      staticClass: "w-full lg:w-auto",
                      attrs: {
                        icon: "calendar",
                        active: "",
                        dropdownIndicator: "",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.triggerLabel?.includes("-")
                              ? _vm.triggerLabel
                              : `${_vm.$t("period")}: ${_vm.triggerLabel}`
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          [
            _c(
              "div",
              { staticClass: "py-2" },
              [
                _vm._l(_vm.optionsList, function (option) {
                  return _c("jade-list-item", {
                    key: option.value,
                    attrs: {
                      as: "button",
                      variant: option.active ? "active" : "primary",
                      label: option.label,
                    },
                    on: {
                      onClick: function ($event) {
                        return _vm.dateFiltersChanged(option)
                      },
                    },
                  })
                }),
                _vm.selectedOption.id === "interval" ||
                _vm.selectedOption.id === "specific_date"
                  ? _c("fieldset", { attrs: { disabled: _vm.loadingList } }, [
                      _c("div", { staticClass: "p-2" }, [
                        _c(
                          "form",
                          {
                            attrs: {
                              action: "javascript:void(0)",
                              name: "formFilter",
                              novalidate: "true",
                            },
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.search.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("hr", {
                              staticClass: "emd-divider _weight_light mb-2",
                            }),
                            _vm.selectedOption.id === "specific_date"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "emd-form-group eu-no-padding",
                                    attrs: { "data-children-count": "1" },
                                  },
                                  [
                                    _c("datepicker", {
                                      attrs: {
                                        type: "simple",
                                        limitDate: _vm.today,
                                        classList: ["_size_small"],
                                        id: "sinceDate",
                                        date: _vm.sinceDate.value,
                                        locale: _vm.locale,
                                        "min-date": _vm.minDate,
                                      },
                                      on: {
                                        changeDate: function ($event) {
                                          return _vm.setSpecificDate($event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.selectedOption.id === "interval"
                              ? [
                                  _c("datepicker", {
                                    attrs: {
                                      type: "range",
                                      limitDate: _vm.today,
                                      start: _vm.sinceDate.text,
                                      end: _vm.untilDate.text,
                                      locale: _vm.locale,
                                      "min-date": _vm.minDate,
                                    },
                                    on: {
                                      changeDate: function ($event) {
                                        return _vm.setIntervalDate($event)
                                      },
                                      onSubmit: _vm.search,
                                    },
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }